export const SET_MESSAGES = 'SET_MESSAGES';
export const SET_CHAT = 'SET_CHAT';
